import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { SeatAction } from './useSeatActions';

const DESCRIPTION: Readonly<Record<SeatAction['kind'], string>> = {
  assignCoaches: 'The assign-coaches dialog on the coaching dashboard.',
  move: 'The move-seat dialog on the coaching dashboard.',
  revoke: 'The end-seat dialog on the coaching dashboard.',
  addCohort: 'The add-to-cohort palette on the coaching dashboard.',
  removeCohort: 'The remove-from-cohort palette on the coaching dashboard.',
  addToCoachRoster: 'The add-to-coaching-roster dialog on the coaching dashboard.',
};

/** The seat dialog standing open, or null where none is. */
export const useAgentContext = (action: SeatAction | null) => {
  useRegisterAgentContext(
    action === null
      ? null
      : {
          kind: 'form',
          description: DESCRIPTION[action.kind],
          data: {
            action: action.kind,
            // A batch names how many rather than who: the roster rows already carry the
            // people, and repeating them here would be one more copy to go stale.
            subject_count: action.holders.length,
            subject_user_ids: action.holders.map((holder) => holder.id),
            acts_on: action.kind === 'assignCoaches' ? null : `${action.seatKind}_seat`,
          },
        },
  );
};
